<div class="card w100" (click)="onClick.emit(streamId)">
    <div class="w100 row space-between gap-8">
        <div class="col">
            @if (category) {
                <div class="row w100 category">
                    <span>{{ category }}</span>
                </div>
            }

            <h4 class="title">{{ title }}</h4>
        </div>
        <div class="row gap-8 space-between">
            <div>
                <p class="credits">{{ credits }} credits</p>
                <p>{{ steps }} steps</p>
            </div>
        </div>
    </div>

    @if (description) {
        <div class="row gap-8 w100 description">
            {{ description }}
        </div>
    }
</div>
